export default __webpack_public_path__ + "img/9b378d9c355bd896ea24633c693c15a3.png";